import { useTranslation } from "next-i18next";
import classes from "./HistoryHeader.module.scss";
import classNames from "classnames";
import { Col, Container } from "react-bootstrap";
import { ComponentPropsWithoutRef } from "react";

interface Props extends ComponentPropsWithoutRef<'div'> { }

const HistoryHeader = ({ className, ...htmlProps }: Props) => {
  const { t } = useTranslation("history");

  return (
    <div className={classNames(className, classes.header)} {...htmlProps}>
      <Col className="d-flex flex-column align-items-center">
        <Container
          className={classNames(classes.header__container, classes)}
        >
          <div>
            <h1 className="display-5 fw-bold mb-3 text-uppercase">
              {t("title")}
            </h1>
            <p className="display-6 text-black">{t("subtitle")}</p>
          </div>
        </Container>
      </Col>
    </div>
  );
};

export default HistoryHeader;
